import * as utils from '../functions/utils';
import { IMainPhoto, IRecentUser } from '../interfaces/IUser';
import User from './user';

export default class RecentUsers {
  detail: User;
  mainPhotoSummary: IMainPhoto;

  constructor() {
    this.detail = new User();
    this.mainPhotoSummary = {
      fullUrl: '',
      photoId: -1,
      isPublic: false,
      thumbUrl: '',
      height: -1,
      width: -1,
      imageType: '',
      imageActionType: '',
      showSafeMode: false,
      galleryId: -1,
    };
  }

  static mappingObject(_obj: any): IRecentUser {
    let obj = Object.assign(new RecentUsers(), _obj);

    obj.detail.ageTitle = _obj.AgeTitle || '';
    obj.detail.userName = _obj.UserName || '';
    obj.detail.memberLevel = utils.getMemberLevel(_obj.MemberLevel, _obj.IsDiamond) || '';
    obj.detail.userId = _obj.MemberID || -1;
    obj.detail.location = _obj.Location || '';
    obj.detail.isOnline = _obj.IsOnline || false;
    obj.detail.isViewable = _obj.hasOwnProperty('IsViewable') ? _obj.IsViewable : true;
    obj.mainPhotoSummary.fullUrl = _obj?.MainPhoto?.FullUrl || '';
    obj.mainPhotoSummary.photoId = _obj?.MainPhoto?.PhotoID || -1;
    obj.mainPhotoSummary.isPublic = _obj?.MainPhoto?.IsPublic || false;
    obj.mainPhotoSummary.showSafeMode = _obj?.MainPhoto?.ShowSafeMode || false;
    obj.mainPhotoSummary.height = _obj?.MainPhoto?.Height || -1;
    obj.mainPhotoSummary.galleryId = _obj?.MainPhoto?.GalleryID || -1;
    obj.mainPhotoSummary.thumbUrl = _obj?.MainPhoto?.ThumbUrl || '';
    obj.mainPhotoSummary.width = _obj?.MainPhoto?.Width || -1;
    obj.mainPhotoSummary.imageType = _obj?.MainPhoto?.ImageType || '';
    obj.mainPhotoSummary.imageActionType = _obj?.MainPhoto?.ImageActionType || '';

    obj = utils.cleanObjectKeys(Object.keys(new RecentUsers()), obj);

    return obj;
  }
}
